import { useEffect, useState } from 'react';

import { Row, Col, Label, FormGroup } from 'twyne-new.ui';

import Input from 'components/formsy/Input';

import APICkecker from '../APICkecker';

export default function Fluent({ name, data = {} }) {
  const [apiKey, setApiKey] = useState('')

  useEffect(() => {
    setApiKey(data.apiKey || '')
  }, [data.apiKey])

  return <>
    <Row>
      <Col size="6">
        <FormGroup>
          <Label>Reporting Key</Label>
          <Input required name="apiKey" value={apiKey} onChange={setApiKey} />
        </FormGroup>
      </Col>
    </Row>
    <APICkecker partner={name} credentials={{ apiKey }} />
  </>
}
